import React, { FC, useState } from "react";
import { useHistory, NavLink } from "react-router-dom";
import { h } from "gridjs";
import { Highlight } from "../../app/models/highlight";
import { listResources } from "../../app/models/admincrud";
import FilterHighlight from "./components/filter-highlight";
import { Grid } from "gridjs-react";

import { Button } from "@material-ui/core";

interface HighlightPageProps {}

const HighlightList: FC<HighlightPageProps> = () => {
  let history = useHistory();

  const columns = [
    {
      id: "id",
      name: "Actions",
      formatter: (cell, row) => {
        return h(
          "a",
          {
            href: `/admin/highlights/${row.cells[0].data}`,
          },
          "Edit"
        );
      },
    },
    "Id",
    "Text",
    "Category",
    {
      id: "sql_query",
      name: "Query (SQL)",
      formatter: (cell, row) => {
        return row.cells[3].data;
      },
    },
    {
      id: "active",
      name: "Active",
      formatter: (cell, row) => {
        return row.cells[4].data ? "True" : "False";
      },
    },
  ];

  const classNa = { table: "question-table" };

  const [dataHighlights, setDataHighlights] = useState<Highlight[]>([]);
  const asyncLoadHighlights = async (filterModel?: {
    [key: string]: string;
  }) => {
    const r = await listResources("highlights", filterModel);
    setDataHighlights(r);
  };

  const onFilterChange = (filterModel) => {
    asyncLoadHighlights(filterModel);
    history.push("?" + new URLSearchParams(filterModel).toString());
  };

  return (
    <div>
      <FilterHighlight onChange={onFilterChange} />
      <NavLink to="/admin/highlights/create" color="primary">
        <Button color="primary" variant="contained">
          Add New
        </Button>
      </NavLink>
      <br />
      <br />
      <Grid
        data={dataHighlights}
        search={false}
        columns={columns}
        className={classNa}
        pagination={{
          enabled: true,
          limit: 25,
        }}
      />
    </div>
  );
};

export default HighlightList;
